type CreateRecommendedPetitionAnglesJobResponse = { responseId: string };

export async function createRecommendedPetitionAnglesJob(): Promise<CreateRecommendedPetitionAnglesJobResponse> {
	// eslint-disable-next-line promise/avoid-new
	return new Promise((resolve) => {
		resolve({ responseId: 'job-123' });
	});
}
